import { render, staticRenderFns } from "./FrzChamberPalletLosses.vue?vue&type=template&id=e21a5304"
import script from "./FrzChamberPalletLosses.vue?vue&type=script&lang=js"
export * from "./FrzChamberPalletLosses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports